// extracted by mini-css-extract-plugin
export default {"button":"NavButton_button__4jYV+"};